import { getReviewApi } from "../../api/home/reviewApi";
import {
  GET_REVIEW_SUCCESS,
  GET_REVIEW_FAILURE,
} from "../types";

export const getReviewSuccess = (homepage) => ({
  type: GET_REVIEW_SUCCESS,
  payload: homepage,
});

export const getReviewFailure = (error) => ({
  type: GET_REVIEW_FAILURE,
  payload: error,
});

export const getReview = (postData) => {
  return (dispatch) => {
    getReviewApi(postData)
      .then((response) => {
        dispatch(getReviewSuccess(response.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(getReviewFailure(error.message));
      });
  };
};
